// Header links (the Manage Links dialog, templates/edit_links.tpl) + the inline-link
// iframe used by links.tpl. DEV-12525: rewritten from Prototype (Template / $() /
// up()/down() / blindDown / Effect) to vanilla + am.$. Every function name is kept —
// this file is concatenated into a js bundle and the templates call these by name.
// The row markup is no longer a JS string template: partials/header_link_row.tpl is
// rendered once into <template id="link_row_template"> with a ~id~ placeholder, and
// add_new_link clones it (one source of truth for the row).

var new_link_template = ''; // legacy global, kept so nothing referencing it throws

function hl_rows_container() {
	return document.getElementById('links');
}

var add_new_link = function(url, name, enforce_normality) {
	if (typeof url != 'string' || !url.trim().length) url = 'http://';
	var tpl = document.getElementById('link_row_template');
	var rows = hl_rows_container();
	if (!tpl || !rows) return false;
	var id = 'n' + new Date().getTime();
	var holder = document.createElement('div');
	holder.innerHTML = tpl.innerHTML.split('~id~').join(id);
	var row = holder.firstElementChild;
	if (!row) return false;
	var nameInput = row.querySelector('input[name$="[name]"]');
	var linkInput = row.querySelector('input.url');
	if (nameInput && typeof name == 'string') nameInput.value = name;
	if (linkInput) linkInput.value = url;
	rows.appendChild(row);
	if (enforce_normality) make_normal(row);
	if (nameInput) nameInput.focus();
	return false;
};

// force the Normal type: links to Allmoxy's own pages (relative URLs) must be normal
function make_normal(row) {
	row = row && row.closest ? row.closest('.linkbox') || row : row;
	var sel = row ? row.querySelector('select') : null;
	if (!sel) return;
	sel.value = 'normal';
	show_link_type_box(sel);
}

// URL input: anything that is not an absolute http(s) URL is an Allmoxy page → Normal
function link_onkey(ev) {
	var el = ev && ev.target ? ev.target : ev;
	if (!el) return;
	var url = (el.value || '').toLowerCase();
	var row = el.closest('.linkbox');
	if (!row) return;
	if (url.indexOf('http://') !== 0 && url.indexOf('https://') !== 0) make_normal(row);
}

// legacy hook (the old template hid the type select behind a span for relative URLs;
// the converted row always shows the select). Kept as a no-op for callers.
function allow_abnormal(el) {}

function add_current_page_as_link() {
	var loc = document.location.toString();
	var base = document.querySelector('base');
	var ba = base ? base.href : '';
	var url = ba ? loc.replace(ba, '') : loc;
	var name = document.title;
	add_new_link(url, name, true);
	return false;
}

// remove a row: the controller deletes every saved link missing from the POST (and
// its HtmlBlock), so dropping the row is the whole action. No bespoke motion.
function remove_link_row(btn) {
	var row = btn && btn.closest ? btn.closest('.linkbox') : null;
	if (row) row.remove();
	return false;
}

// type swap: URL field for every type but html, the HTML textarea for html
function show_link_type_box(sel) {
	var row = sel && sel.closest ? sel.closest('.linkbox') : null;
	if (!row) return;
	var isHtml = sel.value == 'html';
	var urlbox = row.querySelector('.urlbox');
	var htmlbox = row.querySelector('.htmlbox');
	if (urlbox) urlbox.hidden = isHtml;
	if (htmlbox) htmlbox.hidden = !isHtml;
}

function submit_edit_links_form(btn) {
	var form = document.getElementById('links_form');
	if (!form) return false;
	if (btn && btn.classList) btn.classList.add('is-busy'); // canon in-flight ring, blocks a double submit
	am.$.ajax({
		url: form.getAttribute('action'),
		type: 'POST',
		data: new FormData(form),
		processData: false,
		contentType: false,
		success: function(responseText) {
			// the response is links.tpl re-rendered: swap the Favorites submenu items in
			// place, keeping the header row (nav refresh without a page reload)
			var ul = document.getElementById('subnav_links');
			if (ul) {
				var header = ul.querySelector('.dropdown-header');
				var headerLi = header ? header.closest('li') : null;
				ul.innerHTML = '';
				if (headerLi) ul.appendChild(headerLi);
				ul.insertAdjacentHTML('beforeend', responseText);
			}
			add_notification(get_language_translation('LANG_MSG_LINKS_UPDATED_SUCCESSFULLY') + '.', 'success');
			if (typeof Modalbox != 'undefined') Modalbox.hide();
		},
		error: function() {
			add_notification(get_language_translation('LANG_MSG_ERROR_UPDATING_LINKS') + '.', 'danger');
		},
		complete: function() {
			if (btn && btn.classList) btn.classList.remove('is-busy');
		}
	});
	return false;
}

function open_inline_url(url, extra_full) {
	var page = document.getElementById('page');
	if (!page) return false;
	page.innerHTML = '<iframe src="' + url + '" class="full_screen_iframe' + (extra_full ? ' extra_full' : '') + '" id="full_screen_iframe"></iframe>';
	resize_iframe();
	window.addEventListener('resize', resize_iframe);
	return false;
}
var resize_iframe = function() {
	var iframe = document.getElementById('full_screen_iframe');
	if (!iframe) return;
	var header = document.getElementById('content_header');
	var nav = document.getElementById('nav_outer');
	var h = function(el) { return el ? el.getBoundingClientRect().height : 0; };
	iframe.style.height = (window.innerHeight - h(header) - h(nav)) + 'px';
}; // semicolon is load-bearing: this file is concatenated into the js bundles, and a
   // following file opening with ( would otherwise CALL this function expression
